module.exports = __webpack_public_path__ + "img/ttshop_dfh.cc42229a.svg";